import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const Shop = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [activeBrand, setActiveBrand] = useState('All');
  const { addToCart } = useCart();

  const categories = [
    { name: 'All', count: 10 },
    { name: 'Eyeglasses', count: 5 },
    { name: 'Sunglasses', count: 3 },
    { name: 'Contact Lenses', count: 2 },
  ];

  const brands = ['All', 'Oakley', 'Rayban', 'Silhouette', 'Tommy Hilfiger'];

  const products = [
    {
      id: 1,
      title: 'Classic Aviator',
      brand: 'RAYBAN',
      price: '129.99',
      category: 'Sunglasses',
      desc: 'Premium quality sunglasses designed for maximum comfort and style.',
      image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&auto=format'
    },
    {
      id: 2,
      title: 'Metro Square',
      brand: 'OAKLEY',
      price: '89.99',
      category: 'Eyeglasses',
      desc: 'Sleek and modern frames designed for everyday wear and durability.',
      image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=600&auto=format'
    },
    {
      id: 3,
      title: 'Round Vintage',
      brand: 'SILLOUETTE',
      price: '99.99',
      category: 'Eyeglasses',
      desc: 'Classic round frames that bring a touch of vintage elegance to any look.',
      image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?w=600&auto=format'
    },
    {
      id: 4,
      title: 'Sport Pro',
      brand: 'OAKLEY',
      price: '159.99',
      category: 'Sunglasses',
      desc: 'High-performance sports eyewear for the active individual.',
      image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=600&auto=format'
    },
    {
      id: 5,
      title: 'Cat Eye Luxe',
      brand: 'RAYBAN',
      price: '119.99',
      category: 'Sunglasses',
      desc: 'Elegant cat-eye frames for a sophisticated and feminine touch.',
      image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=600&auto=format'
    },
    {
      id: 6,
      title: 'Minimal Frame',
      brand: 'TOMMY HILFIGER',
      price: '79.99',
      category: 'Eyeglasses',
      desc: 'Lightweight and minimal design for maximum comfort throughout the day.',
      image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=600&auto=format'
    },
    {
      id: 7,
      title: 'Wayfarer Classic',
      brand: 'RAYBAN',
      price: '139.99',
      category: 'Sunglasses',
      desc: 'The iconic wayfarer design that never goes out of style.',
      image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=600&auto=format'
    },
    {
      id: 8,
      title: 'Blue Light Guard',
      brand: 'TOMMY HILFIGER',
      price: '94.99',
      category: 'Eyeglasses',
      desc: 'Protect your eyes from digital strain with our blue light blocking technology.',
      image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?w=600&auto=format'
    },
    {
      id: 9,
      title: 'Professional Reader',
      brand: 'OAKLEY',
      price: '110.00',
      category: 'Eyeglasses',
      desc: 'Crystal clear vision for all your reading and professional needs.',
      image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=600&auto=format'
    },
    {
      id: 10,
      title: 'Summer Gold',
      brand: 'SILLOUETTE',
      price: '180.00',
      category: 'Sunglasses',
      desc: 'Luxurious gold-toned frames for the ultimate summer statement.',
      image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&auto=format'
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Banner Section */}
      <section className="relative flex h-[320px] items-center justify-center overflow-hidden sm:h-[360px] lg:h-[400px]">
        <div 
          className="absolute inset-0 z-0 bg-cover bg-center scale-105"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1511499767150-a48a237f0083?q=80&w=2070&auto=format)' }}
        >
          <div className="absolute inset-0 bg-[#2A3182]/70 mix-blend-multiply"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a]/80 to-transparent"></div>
        </div>
        
        <div data-aos="fade-up" className="relative z-10 mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h1 className="mb-4 text-[36px] font-black tracking-tight text-white drop-shadow-2xl sm:text-[46px] md:text-[60px]">
            Our Collection
          </h1>
          <p className="mx-auto max-w-lg text-[14px] font-medium leading-relaxed text-white/90 drop-shadow-lg sm:text-[16px] md:text-[18px]">
            Browse through our extensive range of premium eyewear, from classic frames to modern sunglasses.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <main className="page-container py-12 sm:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:gap-12">
          
          {/* Sidebar Filters */}
          <aside
            className="w-full flex-shrink-0 lg:sticky lg:h-fit lg:max-h-[calc(100vh-130px)] lg:w-[240px] lg:self-start lg:overflow-y-auto lg:pr-2"
            style={{ top: '130px' }}
          >
            <div data-aos="fade-right">
              {/* Categories */}
              <div className="mb-10">
                <h3 className="text-[15px] font-bold text-[#1a1a1a] mb-5 uppercase tracking-[0.1em]">Categories</h3>
                <ul className="space-y-1">
                  {categories.map((cat) => (
                    <li 
                      key={cat.name}
                      onClick={() => setActiveCategory(cat.name)}
                      className={`flex justify-between items-center py-2.5 rounded-lg cursor-pointer transition-all duration-200 text-[14px]
                        ${activeCategory === cat.name 
                          ? 'bg-[#2A3182] text-white shadow-md px-4 font-bold' 
                          : 'text-gray-500 hover:text-[#2A3182] font-medium'}`}
                    >
                      <span>{cat.name}</span>
                      <span className={`text-[11px] ${activeCategory === cat.name ? 'text-white/70' : 'text-gray-400'}`}>
                        ({cat.count})
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Brands */}
              <div>
                <h3 className="text-[15px] font-bold text-[#1a1a1a] mb-5 uppercase tracking-[0.1em]">Brands</h3>
                <ul className="space-y-1">
                  {brands.map((brand) => (
                    <li 
                      key={brand}
                      onClick={() => setActiveBrand(brand)}
                      className={`py-2.5 rounded-lg cursor-pointer transition-all duration-200 text-[14px]
                        ${activeBrand === brand 
                          ? 'bg-[#2A3182] text-white shadow-md px-4 font-bold' 
                          : 'text-gray-500 hover:text-[#2A3182] font-medium'}`}
                    >
                      {brand}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>

          {/* Product Grid Area */}
          <section className="min-w-0 flex-1">
            <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-[12px] font-bold uppercase tracking-widest text-gray-400 sm:text-[13px]">
                Showing {products.length} products
              </p>
              <div className="w-full sm:w-auto">
                <select className="w-full cursor-pointer rounded-lg border border-gray-100 px-3 py-2 text-[12px] font-bold text-gray-500 outline-none focus:border-[#2A3182] sm:w-auto">
                  <option>Default Sorting</option>
                  <option>Price: Low to High</option>
                  <option>Price: High to Low</option>
                  <option>Newest First</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
              {products.map((product, index) => (
                <div key={product.id} data-aos="fade-up" data-aos-delay={index * 50} className="group flex flex-col rounded-[25px] border border-[#ddd] bg-white p-2.5 transition-all duration-500 hover:shadow-xl">
                  {/* Image Container */}
                  <div className="relative aspect-square rounded-[20px] overflow-hidden bg-[#f8f9fa]">
                    <div className="absolute top-3 right-3 z-10">
                      <div className="bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full shadow-sm border border-[#ddd]">
                        <span className="text-[9px] font-black text-[#2A3182] uppercase tracking-tighter">
                          {product.category}
                        </span>
                      </div>
                    </div>
                    <Link to="/product">
                      <img 
                        src={product.image} 
                        alt={product.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                    </Link>
                  </div>

                  {/* Product Details */}
                  <div className="flex flex-1 flex-col p-4 pt-4">
                    <div className="mb-1 flex items-start justify-between gap-3">
                      <Link to="/product">
                        <h3 className="text-[16px] font-bold text-gray-900 group-hover:text-[#2A3182] transition-colors leading-tight">
                          {product.title}
                        </h3>
                      </Link>
                      <span className="text-[9px] font-bold text-gray-300 uppercase tracking-widest mt-1">
                        {product.brand}
                      </span>
                    </div>
                    <p className="text-[12px] text-gray-400 line-clamp-2 mb-4 leading-relaxed flex-1">
                      {product.desc}
                    </p>
                    <div className="flex items-center justify-between gap-3 border-t border-[#ddd] pt-2">
                      <div className="flex items-center gap-0.5">
                        <span className="text-[10px] font-bold text-[#2A3182] opacity-50 uppercase tracking-tighter">Ksh.</span>
                        <span className="text-[18px] font-black text-[#2A3182] tracking-tight">{product.price}</span>
                      </div>
                      <button 
                        onClick={() => addToCart(product)}
                        className="whitespace-nowrap rounded-full bg-[#EF4444] px-4 py-2 text-[11px] font-bold text-white shadow-md transition-all hover:bg-red-600 active:scale-95"
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Shop;
